var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V44.8595C40 45.872 38.9639 46.5541 38.0338 46.1539L20.557 38.6331C20.2014 38.4801 19.7986 38.4801 19.443 38.6331L1.96622 46.1539C1.0361 46.5541 0 45.872 0 44.8595V0Z",
    fill: "#8E51E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.704 15.64H4.274V26H7.97C10.252 26 11.988 25.034 11.988 22.948C11.988 21.548 11.162 20.764 10.042 20.498V20.428C10.924 20.134 11.456 19.112 11.456 18.188C11.456 16.242 9.832 15.64 7.704 15.64ZM7.55 19.854H6.346V17.222H7.578C8.824 17.222 9.44 17.586 9.44 18.496C9.44 19.336 8.894 19.854 7.55 19.854ZM7.788 24.404H6.346V21.394H7.788C9.244 21.394 9.972 21.814 9.972 22.822C9.972 23.9 9.202 24.404 7.788 24.404ZM19.6593 15.64H13.3033V26H19.8133V24.264H15.3753V21.492H19.0153V19.756H15.3753V17.362H19.6593V15.64ZM24.5106 26.196C26.9046 26.196 28.3186 24.754 28.3186 23.06C28.3186 21.548 27.5206 20.764 26.2326 20.246L24.8746 19.672C23.9926 19.336 23.2506 19.014 23.2506 18.314C23.2506 17.628 23.8386 17.222 24.7486 17.222C25.6026 17.222 26.2886 17.53 26.9466 18.076L27.9966 16.774C27.1566 15.92 25.9806 15.444 24.7486 15.444C22.6626 15.444 21.1646 16.746 21.1646 18.44C21.1646 19.952 22.2146 20.778 23.2646 21.226L24.6506 21.814C25.5886 22.22 26.2046 22.43 26.2046 23.214C26.2046 23.942 25.6306 24.404 24.5526 24.404C23.6426 24.404 22.6626 23.942 21.9206 23.256L20.7306 24.684C21.7386 25.65 23.1106 26.196 24.5106 26.196ZM28.4708 17.362H31.3828V26H33.4548V17.362H36.3948V15.64H28.4708V17.362Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBest);
export default __webpack_public_path__ + "static/media/best.bc23c60883244da70db3de3e209a6df1.svg";
export { ForwardRef as ReactComponent };